<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1655.02 1057.87"
  >
    <rect x="206.52" width="65.97" height="684.84" rx="4.99" fill="#8b6000" />
    <rect
      x="185.36"
      y="738.63"
      width="87.13"
      height="319.24"
      rx="4.99"
      fill="#8b6000"
    />
    <rect
      x="1387.93"
      y="738.63"
      width="87.13"
      height="319.24"
      rx="4.99"
      fill="#774e05"
    />
    <rect x="1387.93" width="65.97" height="684.84" rx="7.56" fill="#774e05" />
    <path
      d="M960,729.79H141.38c-4.91,0-8.89-3.69-8.89-8.23V681.65c0-4.54,4-8.23,8.89-8.23H960"
      transform="translate(-132.49 -11.07)"
      fill="#ddad4e"
    />
    <path
      d="M960,673.42h818.62c4.91,0,8.89,3.69,8.89,8.23v39.91c0,4.54-4,8.23-8.89,8.23H960"
      transform="translate(-132.49 -11.07)"
      fill="#ce9f4d"
    />
    <path
      d="M960,729.79h789c6,0,10.85,4.49,10.85,10v19.74c0,5.55-4.86,10-10.85,10H960"
      transform="translate(-132.49 -11.07)"
      fill="#774e05"
    />
    <path
      d="M960,769.6H171c-6,0-10.85-4.49-10.85-10V739.82c0-5.54,4.86-10,10.85-10H960"
      transform="translate(-132.49 -11.07)"
      fill="#8b6000"
    />
    <path
      d="M960,235.7H146.47c-7.72,0-14-5.79-14-12.93V82.4c0-7.15,6.26-12.94,14-12.94H960"
      transform="translate(-132.49 -11.07)"
      fill="#ddad4e"
    />
    <path
      d="M960,69.46h813.53c7.72,0,14,5.79,14,12.94V222.77c0,7.14-6.26,12.93-14,12.93H960"
      transform="translate(-132.49 -11.07)"
      fill="#ce9f4d"
    />
    <ellipse cx="239.5" cy="105.51" rx="10.76" ry="9.95" fill="#bc8f46" />
    <ellipse cx="239.5" cy="177.62" rx="10.76" ry="9.95" fill="#bc8f46" />
    <ellipse cx="1420.92" cy="105.51" rx="10.76" ry="9.95" fill="#aa7e44" />
    <ellipse cx="1420.92" cy="177.62" rx="10.76" ry="9.95" fill="#aa7e44" />
    <path
      d="M960,437H146.47c-7.72,0-14-5.79-14-12.93V283.72c0-7.15,6.26-12.94,14-12.94H960"
      transform="translate(-132.49 -11.07)"
      fill="#ddad4e"
    />
    <path
      d="M960,270.78h813.53c7.72,0,14,5.79,14,12.94V424.09c0,7.14-6.26,12.93-14,12.93H960"
      transform="translate(-132.49 -11.07)"
      fill="#ce9f4d"
    />
    <ellipse cx="239.5" cy="306.83" rx="10.76" ry="9.95" fill="#bc8f46" />
    <ellipse cx="239.5" cy="378.94" rx="10.76" ry="9.95" fill="#bc8f46" />
    <ellipse cx="1420.92" cy="306.83" rx="10.76" ry="9.95" fill="#aa7e44" />
    <ellipse cx="1420.92" cy="378.94" rx="10.76" ry="9.95" fill="#aa7e44" />
    <path
      d="M960,638.34H146.47c-7.72,0-14-5.79-14-12.93V485c0-7.15,6.26-12.94,14-12.94H960"
      transform="translate(-132.49 -11.07)"
      fill="#ddad4e"
    />
    <path
      d="M960,472.1h813.53c7.72,0,14,5.79,14,12.94V625.41c0,7.14-6.26,12.93-14,12.93H960"
      transform="translate(-132.49 -11.07)"
      fill="#ce9f4d"
    />
    <ellipse cx="239.5" cy="508.15" rx="10.76" ry="9.95" fill="#bc8f46" />
    <ellipse cx="239.5" cy="580.26" rx="10.76" ry="9.95" fill="#bc8f46" />
    <ellipse cx="1420.92" cy="508.15" rx="10.76" ry="9.95" fill="#aa7e44" />
    <ellipse cx="1420.92" cy="580.26" rx="10.76" ry="9.95" fill="#aa7e44" />
  </svg>
</template>

<script>
export default {
  name: "BenchIcon"
};
</script>
